const initialState = {
  index: [],
  data: {},
};

const Patient = (state = initialState, action) => {
  switch (action.type) {
    case "PATIENT_INDEX":
      return { ...state, index: action.payload.index };
    case "PATIENT_DATA":
      return { ...state, data: action.payload.data };
    case "PATIENT_RESET":
      return initialState;
    default:
      return state;
  }
};

export default Patient;
